var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"none"}},[_c('div',{ref:"marker",staticClass:"o-map-drag-marker__content"},[_c('o-icon',{staticClass:"o-map-drag-marker__icon",attrs:{"name":"map-marker-alt"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }